module.exports = __webpack_public_path__ + "img/pageDirector_function.68750306.svg";